import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import { ThemeProvider } from "@/theme";
import Home from "@/pages/Home";
import PaymentResult from "@/pages/PaymentResult";
import RahaltyPage from "@/pages/RahaltyPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangProvider>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/rahalty" element={<RahaltyPage />} />
            <Route path="/payment/success" element={<PaymentResult kind="success" />} />
            <Route path="/payment/cancel" element={<PaymentResult kind="cancel" />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </ThemeProvider>
    </LangProvider>
  );
}

export default App;
